import { Map } from 'immutable';
import * as orderActions from '../actions/orders';
import * as fetchingState from '../constants/fetchingState';
import orderItemsReducer from './orderItemsReducer';
import { getAddressString } from '../extensions/addressHelper';
import moment from 'moment';
import { getErrorMessage } from '../constants/errorCode';
import { defaultHighlightColor } from '../constants/orderStates';

const getClientTimeZoneOffset = () => {
    return new Date().getTimezoneOffset() / 60;
};

const convertToLocalTime = (utcTime, timeZoneOffset) => {
    return utcTime ? moment(utcTime).utcOffset(timeZoneOffset).toDate() : undefined;
};

const initialState = new Map({
    fetching: fetchingState.INITIAL,
    orders: [],
    pages: 0,
    updateFetching: fetchingState.INITIAL,
    updateResult: undefined,
    error: undefined,
    updateError: undefined,
    workTime: {
        pickup: null,
        offload: null,
        pickupFetching: fetchingState.INITIAL,
        offloadFetching: fetchingState.INITIAL
    }
});

export default function(state, action) {
    if (action.data && action.data.refresh) {
        sessionStorage.removeItem('adm-token');
        return initialState;
    }

    switch (action.type) {
        case orderActions.FETCH_DEBUG_ORDER_INFO:
            state = state.update('debugInfoFetching', () => fetchingState.FETCHING);
            state = state.update('fullOrderInfo', () => undefined);
            break;
        case orderActions.SUCCESS_DEBUG_ORDER_INFO:
            state = state.update('debugInfoFetching', () => fetchingState.FETCHED);
            state = state.update('fullOrderInfo', () => action.data);
            break;
        case orderActions.FAILURE_DEBUG_ORDER_INFO:
            state = state.update('debugInfoFetching', () => fetchingState.FAILED);
            state = state.update('fullOrderInfo', () => undefined);
            break;
        case orderActions.FETCH_ORDERS:
            state = state.update('fetching', () => fetchingState.FETCHING);
            state = state.update('orderItems', () => new Map());
            state = state.update('error', () => undefined);
            break;
        case orderActions.SUCCESS_FETCH_ORDERS:
            action.data.Orders.forEach(o => o.PickupAddressString = getAddressString(o.PickupAddress));
            state = state.update('fetching', () => fetchingState.FETCHED);
            const timeZoneOffset = getClientTimeZoneOffset();
            const orders = action.data.Orders.map(o => ({
                ...o,
                PickupDate: convertToLocalTime(o.PickupDate, timeZoneOffset),
                OffloadDate: convertToLocalTime(o.OffloadDate, timeZoneOffset),
                HighlightColor: o.HighlightColor ? o.HighlightColor : defaultHighlightColor
            }));
            state = state.update('orders', () => orders);
            state = state.update('pendingOrdersCount', () => action.data.PendingOrdersCount);
            state = state.update('error', () => undefined);
            if (action.data.Pages !== null)
                state = state.update('pages', () => action.data.Pages);
            break;
        case orderActions.FAILURE_FETCH_ORDERS:
            state = state.update('fetching', () => fetchingState.FAILED);
            state = state.update('error', () => getErrorMessage(action.data.error));
            break;
        case orderActions.UPDATE_ORDER:
            state = state.update('updateFetching', () => fetchingState.FETCHING);
            state = state.update('updateError', () => undefined);
            break;
        case orderActions.SUCCESS_UPDATE_ORDER:
            if (action.data.error === undefined) {
                state = state.update('updateFetching', () => fetchingState.FETCHED);
                state = state.update('updateError', () => undefined);
                break;
            }
        case orderActions.FAILURE_UPDATE_ORDER:
            state = state.update('updateFetching', () => fetchingState.FAILED);
            state = state.update('updateResult', () => action.data);
            state = state.update('updateError', () => getErrorMessage(action.data.error));
            break;
        case orderActions.CLEAR_UPDATE_ORDER:
            state = state.update('updateFetching', () => fetchingState.INITIAL);
            break;
        case orderActions.CREATE_ORDERS:
            state = state.update('updateFetching', () => fetchingState.FETCHING);
            state = state.update('updateError', () => undefined);
            break;
        case orderActions.SUCCESS_CREATE_ORDERS:
            state = state.update('updateFetching', () => fetchingState.FETCHED);
            state = state.update('updateError', () => undefined);
            break;
        case orderActions.FAILURE_CREATE_ORDERS:
            state = state.update('updateFetching', () => fetchingState.FAILED);
            state = state.update('updateError', () => getErrorMessage(action.data.error));
            break;
        case orderActions.CLEAR_ORDERS:
            state = state.update('orders', () => []);
            state = state.update('fetching', () => fetchingState.INITIAL);
            state = state.update('pages', () => 0);
            break;
        case 'GET_PENDING_ORDERS_COUNT_SUCCESS':
            if (!action.data.error)
                state = state.update('pendingOrdersCount', () => action.data);
            break;
        case 'CLEAR_PENDING_ORDERS_COUNT':
            state = state.update('pendingOrdersCount', () => 0);

        case orderActions.GET_AVAILABLE_PICKUP_DATE:
            state = state.update('workTime', (wt) => ({...wt, pickupFetching: fetchingState.FETCHING }));
            break;
        case orderActions.SUCCESS_AVAILABLE_PICKUP_DATE:
            action.data = action.data && action.data.length > 0 ? action.data.map((d, index) => _getDateTimeWrapper(d, index)) : [];
            state = state.update('workTime', (wt) => ({
                ...wt,
                pickupFetching: fetchingState.FETCHED,
                pickup: action.data
            }));
            break;
        case orderActions.FAILURE_AVAILABLE_PICKUP_DATE:
            state = state.update('workTime', (wt) => ({...wt, pickupFetching: fetchingState.FAILED }));
            break;

        case orderActions.GET_AVAILABLE_OFFLOAD_DATE:
            state = state.update('workTime', (wt) => ({...wt, offloadFetching: fetchingState.FETCHING }));
            break;
        case orderActions.SUCCESS_AVAILABLE_OFFLOAD_DATE:
            action.data = action.data && action.data.length > 0 ? action.data.map((d, index) => _getDateTimeWrapper(d, index)) : [];
            state = state.update('workTime', (wt) => ({
                ...wt,
                offloadFetching: fetchingState.FETCHED,
                offload: action.data
            }));
            break;
        case orderActions.FAILURE_AVAILABLE_OFFLOAD_DATE:
            state = state.update('workTime', (wt) => ({...wt, offloadFetching: fetchingState.FAILED }));
            break;
        case orderActions.CLEAR_PICKUP_AND_OFFLOAD_DATE:
            state = state.update('workTime', wt => ({...initialState.workTime }));
            break;
        case orderActions.FETCH_MANUAL_COMPLETION:
            state = state.update('updateFetching', () => fetchingState.FETCHING);
            state = state.update('updateError', () => undefined);
            break;
        case orderActions.SUCCESS_MANUAL_COMPLETION:
            state = state.update('updateFetching', () => fetchingState.FETCHED);
            state = state.update('updateError', () => undefined);
            break;
        case orderActions.FAILURE_MANUAL_COMPLETION:
            state = state.update('updateFetching', () => fetchingState.FAILED);
            state = state.update('updateError', () => getErrorMessage(action.data.error));
        case orderActions.CLEAR_PICKUP_AND_OFFLOAD_DATE:
            state = state.update('workTime', wt => ({...initialState.workTime }));
            break;
        default:
            break;
    }
    state = state.update('orders', (orders) => orderItemsReducer(orders, action));
    return state;

    function _getDateTimeWrapper(date, index) {
        var momentDate = moment(date);
        return {
            Index: index,
            Date: date,
            DateString: momentDate.format('DD.MM.yyyy'),
            StartTime: momentDate.format('HH:mm'),
            EndTime: momentDate.add(2, 'hours').format('HH:mm')
        }
    }
};


// WEBPACK FOOTER //
// ./src/reducers/orderReducer.js